export default __webpack_public_path__ + "static/media/wap.69a72697.png";